import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FooterPanel } from './components/index';
import { useWindowSize } from '../../utils/hooks';
import { layoutResponsive, maxMobileSize } from '../../utils/constants';
import AppNotification from '../common/AppNotification/AppNotification';
import Sidebar from './components/Sidebar/Sidebar';
import TopBar, { TopBarProvider } from './components/TopBar/TopBar';

const SIDEBAR_W_EXPANDED  = 220;
const SIDEBAR_W_COLLAPSED = 64;

export default function Layout({ children }) {
  const size            = useWindowSize();
  const location        = useLocation();
  const appNotification = useSelector((s) => s.appNotifications?.message);

  const [notification, setNotification] = useState(null);
  const [collapsed, setCollapsed]       = useState(false);
  const [pageKey, setPageKey]           = useState(location.pathname);

  useEffect(() => { setNotification(appNotification); }, [appNotification]);

  useEffect(() => {
    setPageKey(location.pathname);
  }, [location.pathname]);

  const isMobile    = size.width < maxMobileSize;
  const sidebarW    = isMobile ? 0 : collapsed ? SIDEBAR_W_COLLAPSED : SIDEBAR_W_EXPANDED;

  const showFooter  = size.width <= layoutResponsive
    && !(location.pathname.includes('jobs') && location.search.includes('id='));

  return (
    <TopBarProvider>
      <style>{`
        @keyframes page-fade-in {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0);   }
        }
        @keyframes topbar-slide-down {
          from { opacity: 0; transform: translateY(-100%); }
          to   { opacity: 1; transform: translateY(0);     }
        }
        .page-enter {
          animation: page-fade-in 0.22s cubic-bezier(0.4,0,0.2,1) both;
        }
        .topbar-mount {
          animation: topbar-slide-down 0.28s cubic-bezier(0.4,0,0.2,1) both;
        }
      `}</style>

      <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />

      <div
        className="topbar-mount"
        style={{
          position: 'fixed',
          top: 0,
          left: sidebarW,
          right: 0,
          zIndex: 99,
          transition: 'left 0.2s ease-in-out',
        }}
      >
        <TopBar />
      </div>

      <div
        style={{
          marginLeft: sidebarW,
          transition: 'margin-left 0.2s ease-in-out',
          minHeight: '100vh',
        }}
        className="flex flex-col min-w-0 overflow-x-hidden bg-[#F0F4F7] pt-14 pb-20 md:pb-0"
      >
        <main key={pageKey} className="page-enter flex flex-col flex-1 min-w-0">
          {children}
        </main>

        {showFooter && <FooterPanel />}
      </div>

      <AppNotification notification={notification} />
    </TopBarProvider>
  );
}